import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './store'
import * as firebase from "firebase"

Vue.config.productionTip = false

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyBFFL9AEO6UDbM74y8e1RfceJA0MGgQqOM",
  authDomain: "evolved-1c8a1.firebaseapp.com",
  databaseURL: "https://evolved-1c8a1.firebaseio.com",
  projectId: "evolved-1c8a1",
  storageBucket: "evolved-1c8a1.appspot.com",
  messagingSenderId: "1046892940205",
  appId: "1:1046892940205:web:d5af748bb1cd081cd5ef24",
  measurementId: "G-EJJF0R2PRE"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

firebase.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
});

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
